import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { useCurrentUser } from '../../../hooks';
import {
  edit_affiliate_settings_path,
  edit_topics_settings_path,
  edit_user_email_settings_path,
  edit_user_privacy_settings_path,
  edit_user_team_settings_path,
  group_subscriptions_settings_path,
  user_dashboard_path,
} from '../../../routes.js';
import styles from './styles.module.scss';

const SETTING_NAV_OPTIONS = [
  { value: user_dashboard_path, label: 'Account', access: false },
  { value: edit_affiliate_settings_path, label: 'Referral', access: false },
  { value: edit_topics_settings_path, label: 'Following', access: false },
  { value: edit_user_email_settings_path, label: 'Email Preferences', access: false },
  { value: group_subscriptions_settings_path, label: 'Gift Subscriptions', access: false },
  { value: edit_user_team_settings_path, label: 'Team Subscriptions', access: false },
  { value: edit_user_privacy_settings_path, label: 'Privacy', access: false },
];

const Layout = ({ activeItem }: { activeItem: string }) => {
  const currentActiveItem = SETTING_NAV_OPTIONS.find((option) => option.label === activeItem);
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const [navSettings, setNavSettings] = useState(SETTING_NAV_OPTIONS);

  useEffect(() => {
    if (!isLoadingCurrentUser) {
      setNavSettings((prevNavSettings) =>
        prevNavSettings.map((option) => {
          switch (option.label) {
            case 'Privacy':
              return { ...option, access: currentUser?.settings_access_obj?.privacy_access };
            default:
              return { ...option, access: true };
          }
        })
      );
    }
  }, [isLoadingCurrentUser, currentUser?.settings_access_obj?.privacy_access]);

  if (isLoadingCurrentUser) {
    return null;
  }

  return (
    <>
      <div className={styles.settingsHeaderContainer}>
        <div className={styles.settingsHeader}>Settings</div>
        <div className={styles.settingNavMobile}>
          <Select
            options={navSettings.filter((option) => option.access)}
            onChange={(e) => (window.location = e.value())}
            defaultValue={currentActiveItem}
            isSearchable={false}
          />
        </div>
      </div>
      <div className={styles.settingsNavContainer}>
        <div>
          {navSettings
            .filter((option) => option.access)
            .map((option) => (
              <div
                id={option.label}
                key={option.label}
                className={clsx(styles.navItem, {
                  [styles.activeNavItem]: currentActiveItem.label === option.label,
                })}
                onClick={() => (window.location = option.value())}
              >
                {option.label}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Layout;
